module.exports = __webpack_public_path__ + "img/section-meter-gas-meter-md.eb993990.svg";